import CheckIcon from './component.jsx'
export default CheckIcon
